import { TranslocoPipe } from '@jsverse/transloco';
import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { JsonViewerComponent as DaschJsonViewerComponent } from '@dasch-ng/json-viewer';
import { CopyButtonComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-json-viewer',
    templateUrl: './json-viewer.component.html',
    styleUrls: ['./json-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe, DaschJsonViewerComponent, CopyButtonComponent, JsonPipe],
})
export class JsonViewerComponent {
    @Input({ required: true })
    json!: object;

    @Input()
    expanded: boolean = true;
}
